import share from './reducers/share';
import assessments from './reducers/assessments';

export default {
    share: {
        reducer: share,
    },
    assessment: {
        reducer: assessments,
    },
};
